RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.TrackedPages = Backbone.Collection.extend({
        model: Admin.models.TrackedPage,

        initialize: function (data) {
            const me = this;
            me.url = `/admin/api/companies/${data.companyId}/urls`;

            me.listenTo(me, 'change:is_primary', me.setPrimary);
            me.listenTo(me, 'add', me.onAdd);
        },

        onAdd: function (model) {
            const me = this;
            if (me.length === 1) {
                model.set({
                    is_primary: true
                });
            }
        },

        setPrimary: function (model) {
            const me = this;
            if (model.get('is_primary')) {
                me.each(function (handle) {
                    if (handle.get('id') !== model.get('id')) {
                        handle.set({
                            is_primary: false
                        });
                    }
                });
            }
        },

        fetch: function (options) {
            const me = this;
            return $.when(me.loadPageTypes(), Backbone.Collection.prototype.fetch.call(me, options));
        },

        loadPageTypes: function () {
            const me = this;

            const pageTypes = new collections.PageTypes();

            const typeDeferred = new $.Deferred();
            const deferred = RivalIQ.utils.async.callbackToDeferred(function (error) {
                if (error) {
                    typeDeferred.reject(error);
                }

                me.pageTypes = pageTypes;
                me.trigger('change:pageTypes');
                typeDeferred.resolve();
            });

            pageTypes.fetch().done(deferred.resolve).fail(deferred.reject);

            return typeDeferred;
        }
    });
});
